import React from "react";
// import "./TermsAndConditions.css";

const PrivacyPolicy = () => {
    return (
        <div className="tc-container">
            <h1 className="tc-title">Privacy Policy</h1>

            <section className="tc-section">
                <h2>1. Data Collection</h2>
                <p>
                    Way4Track collects personal and technical information to process orders,
                    provide services, and maintain system security.
                </p>

                <p><strong>a) Personal Information</strong></p>
                <ul>
                    <li>Name</li>
                    <li>Phone number</li>
                    <li>Email address</li>
                    <li>Billing and shipping address</li>
                </ul>

                <p><strong>b) Transaction Information</strong></p>
                <ul>
                    <li>Order details</li>
                    <li>Payment confirmation via secure gateways</li>
                </ul>

                <p><strong>c) Technical & Usage Data</strong></p>
                <ul>
                    <li>IP address</li>
                    <li>Device information</li>
                    <li>Browser type</li>
                    <li>Website usage data</li>
                </ul>

                <p>
                    Data is collected directly from users or automatically through system processes.
                </p>
            </section>

            <section className="tc-section">
                <h2>2. Purpose of Data Usage</h2>
                <ul>
                    <li>Processing and fulfilling orders</li>
                    <li>Shipping, delivery, and tracking</li>
                    <li>Customer support and communication</li>
                    <li>Fraud detection and prevention</li>
                    <li>Improving website performance</li>
                    <li>Sending order updates and promotions (if applicable)</li>
                </ul>
            </section>

            <section className="tc-section">
                <h2>3. Data Sharing & Disclosure</h2>

                <p><strong>a) Payment Providers</strong></p>
                <p>
                    Payments are processed securely through third-party providers such as Razorpay.
                </p>

                <p><strong>b) Logistics Partners</strong></p>
                <p>
                    Data is shared for order dispatch, delivery, and tracking.
                </p>

                <p><strong>c) Service Providers</strong></p>
                <p>
                    Includes hosting, analytics, and technical services.
                </p>

                <p>
                    Data may also be disclosed if required by law or government authorities.
                </p>

                <p>
                    Way4Track does not sell personal data to third parties.
                </p>
            </section>

            <section className="tc-section">
                <h2>4. Data Security</h2>
                <p>
                    Reasonable security measures are implemented to protect user data.
                </p>
                <ul>
                    <li>No system is completely secure</li>
                    <li>Users must protect their account credentials</li>
                </ul>
            </section>

            <section className="tc-section">
                <h2>5. Data Retention</h2>
                <ul>
                    <li>To provide services and support</li>
                    <li>To comply with legal obligations</li>
                    <li>To maintain transaction records</li>
                    <li>To resolve disputes</li>
                </ul>
                <p>
                    Some data may be retained even after account closure if required by law.
                </p>
            </section>

            <section className="tc-section">
                <h2>6. User Rights</h2>
                <ul>
                    <li>Request access to personal data</li>
                    <li>Request corrections</li>
                    <li>Opt out of promotional communication</li>
                </ul>
                <p>
                    Requests can be made through official support channels.
                </p>
            </section>

            <section className="tc-section">
                <h2>7. Legal Use of Data</h2>
                <p>
                    System-generated records such as IP address, timestamps, and device logs
                    may be used for fraud prevention, dispute resolution, and legal proceedings.
                </p>
                <p>
                    These records may be presented as valid evidence where required.
                </p>
            </section>

        </div>
    );
};

export default PrivacyPolicy;